import { Space, TableColumnsType } from 'antd';

import { PagamentoWithDettaglioDTO, RichiestaDTO } from '@framework/api-client';
import {
  PaymentBurdenTypeTags,
  SubmissionLogic,
  paymentsColumns,
} from '@framework/frontoffice-submission';
import { TableData } from '@framework/ui';

import { useTranslation } from '@framework/i18n';
import { DeletePaymentButton } from './buttons/DeletePaymentButton';
import { DownloadPaymentAlertButton } from './buttons/DownloadPaymentAlertButton';
import { DownloadPaymentReceiptButton } from './buttons/DownloadPaymentReceiptButton';
import { StartPaymentButton } from './buttons/StartPaymentButton';
import { StartStampDutyPaymentButton } from './buttons/StartStampDutyPayment';

interface PaymentsTableProps {
  payments: PagamentoWithDettaglioDTO[];
  readonly?: boolean;
  submission: RichiestaDTO;
}

export function PaymentsTable(props: PaymentsTableProps) {
  const { payments, readonly = false, submission } = props;
  const { t } = useTranslation();

  const isSubmissionPayable = SubmissionLogic.isSubmissionPayable(submission);

  return (
    <TableData
      size="small"
      pagination={false}
      dataSource={payments}
      columns={
        [
          ...paymentsColumns,
          {
            title: t('payment-table.tipi', 'Tipo'),
            key: 'payment_burder_type',
            render: (_, record) => <PaymentBurdenTypeTags payment={record} />,
          },
          {
            title: t('payment-table.azioni', 'Azioni'),
            key: 'actions',
            align: 'right',
            hidden: readonly,
            render: (_, record) =>
              // in caso di richiesta NON PAGABILE non è possibile effettuare alcuna
              // azione sui pagamenti
              !isSubmissionPayable ? (
                <Space>
                  <DownloadPaymentReceiptButton payment={record} />
                </Space>
              ) : (
                <Space>
                  <DeletePaymentButton payment={record} />
                  <DownloadPaymentAlertButton payment={record} />
                  <DownloadPaymentReceiptButton payment={record} />
                  <StartPaymentButton payment={record} />
                  <StartStampDutyPaymentButton
                    payment={record}
                    submission={submission}
                  />
                </Space>
              ),
          },
        ] satisfies TableColumnsType<PagamentoWithDettaglioDTO>
      }
    />
  );
}
